import { Label } from '../../../components/ui/label';
import { Tabs, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { usePipelineContext } from '../../../entities/pipeline/model/usePipelineContext';

/** Ведёт ли человек «Отработано» своими публикациями — раздающая Редакции. */
export function useLogsWork(): boolean {
  return usePipelineContext().hasRole('distributor');
}

/**
 * «По задаче» / «Без ТЗ» прямо в форме публикации (26.10.2026): Саяна
 * помечает ролик одним нажатием, и он ложится в «Отработано» уже с пометкой
 * и ссылками всех пабликов. Видна только раздающей.
 */
export function WorkBriefToggle({ value, onChange, scheduled = false }: {
  value: boolean;
  onChange: (withBrief: boolean) => void;
  /** Отложенная: ссылок ещё нет, сама запись не появится. */
  scheduled?: boolean;
}) {
  if (!useLogsWork()) return null;
  return (
    <div className="space-y-2" data-testid="work-brief">
      <Label>В «Отработано»</Label>
      <Tabs value={value ? 'brief' : 'free'} onValueChange={(v) => onChange(v === 'brief')}>
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="brief">По задаче</TabsTrigger>
          <TabsTrigger value="free">Без ТЗ</TabsTrigger>
        </TabsList>
      </Tabs>
      <p className="text-xs text-muted-foreground">
        {scheduled
          ? 'Отложенная публикация сама в «Отработано» не попадёт — добавьте запись, когда пост выйдет.'
          : 'Ссылки всех пабликов запишутся сами — отмечать ничего не нужно.'}
      </p>
    </div>
  );
}
